<aur-card emphasis="subdued">
  <div class="subtotal-section" id="sub-total">
    <span class="subtotal-align"
      >{{ 'ARC_PAYMENT_SUBTOTAL' | translate }}:</span
    >
    <span class="subtotal-amount"
      >{{ subTotal | currency }} {{ currencyCode }}</span
    >
  </div>

  <div
    *ngIf="isDiscountAmountVisible"
    class="subtotal-discount-section"
    id="disc-amt-sub-total"
  >
    <span class="subtotal-align">
      ({{ discountAmountSubTotal | currency }}
      {{ currencyCode }}
      {{ 'ARC_PAYMENT_DISCOUNT_APPLIED' | translate | titlecase }})</span
    >
  </div>

  <div
    *ngIf="creditMemoSubTotal < 0"
    class="subtotal-section"
    id="credit-memo-amount-sub-total"
  >
    <span class="subtotal-align"
      >{{ 'ARC_PAYMENT_CREDIT_MEMO_AMOUNT' | translate }}:</span
    >
    <span class="subtotal-amount"
      >{{ creditMemoSubTotal | currency }} {{ currencyCode }}</span
    >
  </div>

  <div *ngIf="surchargeFeeVisible" class="subtotal-section" id="surcharge-fees">
    <span
      class="subtotal-align"
      *ngIf="!surchargeFeePercentageVisible; else surchargeWithPercentage"
      >{{ 'ARC_PAYMENT_SURCHARGE_FEE' | translate }}:</span
    >
    <ng-template #surchargeWithPercentage>
      <span class="subtotal-align">
        {{ 'ARC_PAYMENT_SURCHARGE_FEE' | translate }} ({{
          surchargeFeePercentage | number: '1.2-2'
        }}%):
      </span>
    </ng-template>
    <span class="subtotal-amount" id="surcharge-fees-amount"
      >{{
        surchargeFeeAmount ? (surchargeFeeAmount | currency) : (0 | currency)
      }}
      {{ currencyCode }}
    </span>
  </div>

  <footer class="body-md total-section" id="total-amount">
    <div class="total-section-rule" id="total-section-rule">
      <span class="subtotal-align"
        >{{ 'ARC_PAYMENT_TOTAL_AMOUNT' | translate }}:</span
      >
      <span class="total-amount"
        >{{ totalAmount + (creditMemoSubTotal ?? 0) | currency }}
        {{ currencyCode }}</span
      >
      <div *ngIf="!isZeroDollarPaymentEnabled && creditMemoSubTotal < 0">
        <span class="body editable-payable-amount-warning"
          >{{ 'ARC_PAYMENT_ZERO_DOLLAR_NOTIFICATION' | translate }}
          {{ 0 | currency }} {{ currencyCode }}</span
        >
      </div>
      <div
        *ngIf="showCutOffMessaging"
        class="cut-off-time-container"
        id="cut-off-time-messaging"
      >
        <payment-payable-cutoff-time-text
          class="payable-amount-section-cutoff-text"
          [cutOffTime]="cutOffTime"
        ></payment-payable-cutoff-time-text>
      </div>
    </div>
  </footer>
</aur-card>
